module.exports = __webpack_public_path__ + "static/media/14-junk-is-no-good-baby.fe8b0d88.mp3";